import api from "./api";

export const getsSerie = async () => {
    const response = await api.get("/Serie/GetsSerie");

    return response.data.data;
}

export const obtenerSiguienteNumero = async (idSerie) => {
    const response = await api.get(`/Serie/ObtenerSiguienteNumero?idSerie=${idSerie}`);

    return response.data.data;
}
